import { useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { environnement } from '@/config/env';
import { AuthProvider } from '@/shared/auth/AuthProvider';
import { creerRouteur } from './routes';

export function App() {
  const [routeur] = useState(creerRouteur);

  if (!environnement.ok) return <ConfigurationManquante erreurs={environnement.erreurs} />;

  return (
    <AuthProvider>
      <RouterProvider router={routeur} />
    </AuthProvider>
  );
}

/** Sans projet Supabase, l'application le dit au lieu d'afficher une page blanche. */
function ConfigurationManquante({ erreurs }: { erreurs: string[] }) {
  return (
    <div className="grid min-h-full place-items-center p-6">
      <div className="max-w-lg rounded-2xl border border-border bg-surface p-6 shadow-card">
        <h1 className="text-xl font-bold">Configuration incomplète</h1>
        <ul className="mt-3 list-disc pl-5 text-[13px] text-danger">
          {erreurs.map((e) => (
            <li key={e}>{e}</li>
          ))}
        </ul>
        <p className="mt-4 text-[13px] text-muted">
          Copiez <code>.env.example</code> en <code>.env.local</code> et renseignez le projet
          Supabase, ou lancez <code>npm run dev:demo</code> pour voir l’application sur des données
          fictives.
        </p>
      </div>
    </div>
  );
}
